import { ref } from 'vue';

const useAuthenticatedFetch = (tourSlug: string, locale?: string) => {
  const isLoading = ref(false);
  const authenticatedFetch = async (endPoint: string, method: string = "GET"): Promise<Response> => {
    // Retrieve CSRF token from meta tag or global variable
    isLoading.value = true;
    await fetch("/sanctum/csrf-cookie", {
      method: "GET",
      credentials: "include"
    });

    // add locale to the endPoint
    if (locale) {
      if (endPoint.includes("?")) {
        endPoint += `&locale=${locale}`;
      } else {
        endPoint += `?locale=${locale}`;
      }
    }

    const response = await fetch(`/api/public/${tourSlug}/${endPoint}`, {
      method,
      headers: {
        "Accept": "application/json",
        "X-CSRF-TOKEN": window.Laravel.csrfToken,
      },
    });

    isLoading.value = false;
    return response;
  }

  return {
    isLoading,
    authenticatedFetch
  }
}

export default useAuthenticatedFetch;
